export const StaticConst = {
    MaxPageSize: 99999999
};
